<div id="wrapper" class="flex row-gap-1" *ngIf="parsedGraphicsData">
  <div id="agendaWrapper" class="min-width-13 column-flex-end first-level-left-sticky bg-unset">
    <div id="agenda" class="start-column-container column-gap-0p5 bg-black-2 padding-1 br-0p5">
      <div *ngFor="let a of data?.agenda" class="centered-row-container row-gap-0p5 clickable"
        [class.opacity0p5]="a.blurred" (click)="toggleColor(a.color)">
        <div class="dot" [style.background-color]="a.color"></div>
        <span class="font-3">{{a.title}}</span>
      </div>
    </div>
  </div>
  <div class="overflow-auto width-100pcnt">
    <!-- height-99pcnt - kostil to remove x-Axes-green scroll bar on  -->
    <div id="graphicsWrapper" class="vertical-container-simple height-99pcnt"
      *ngVar="parsedGraphicsData.graphics.length as length"
      [style.min-width]="length > COUNT_PER_GRAPHIC ? length * WIDTH_PER_GRAPHIC + '%': 'auto'">

      <div *ngFor="let i of parsedGraphicsData.yAxis" class="flex-end row-gap-1 height-100pcnt">
        <span class="caption-2 opacity0p64 left-sticky-0p25 bg-black-2 pd-0p125 br-0p25">{{i | prefixSuffix: '': '': false}}</span>
        <div class="width-100pcnt" [ngClass]="i===0 ? 'solid-line':'dashed-line'"></div>
      </div>

      <!-- Custom height to reduce a height for 1 y-row because the top box is not needed.  -->
      <div class="graphics"
        [style.height]="100*((parsedGraphicsData.yAxis.length-1) / parsedGraphicsData.yAxis.length) + '%'">
        <div class="centered-row-container-flex-start height-100pcnt">
          <div [id]="'graph' + iIndex" *ngFor="let i of parsedGraphicsData.graphics; let iIndex = index"
               class="flex-end-bottom row-gap-1 width-100pcnt height-100pcnt position-rel"
               [style.min-width]="(i.title.length > 9 ? i.title.length : 9)  + 'rem' "
               (mouseenter)="activateTooltip('graph' + iIndex, i)"
               >
            <ng-container *ngFor="let j of i.bars; let jIndex = index">
              <div  class="height-100pcnt column-flex-end position-abs" [style.bottom]="j.bottom + '%'"
                [style.left]="2*jIndex + 'rem'">
                <div *ngFor="let k of j.parts; let kIndex = index" class="part"
                  [class.end-of-part-top]="kIndex === 0 && k.isPositive"
                  [class.end-of-part-bottom]="kIndex === j.parts.length-1 && !k.isPositive"
                  [style.height]="k.pcntAmount*100+'%'" [style.background-color]="k.color">
                </div>
              </div>
            </ng-container>

            <div class="height-100pcnt column-flex-end position-abs" [style.left]="2*i.bars.length + 'rem'">
              <span class="font-3 bold600">{{i.title | linkShort: 20}}</span>
              <div [style.height]="i.yAxisZero + '%'"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-tooltip
  *ngIf="toolTipSettings.show"
  [coordinates]="toolTipSettings.coordinates"
  [freezeOnHover]="true"
  [yShift]="'-2.5rem'"
  (mouseleave)="toolTipSettings.show = false">
    <div *ngFor="let g of toolTipSettings.graphic.bars">
      <ng-container *ngFor="let p of g.parts">
        <div class="bold600 width-17p5 start-row-container">
          <div class="dot" [style.background-color]="p.color"></div>
          <span class="font-3 bold400 pd-0p2">{{p.legendHeading}}:</span>
          <span>{{p.amount | prefixSuffix: '': '': true}}<br></span>
        </div>
      </ng-container>
  </div>
</app-tooltip>
